import { render } from "./AllBalancesHomeView.vue?vue&type=template&id=b88803ce&scoped=true"
import script from "./AllBalancesHomeView.vue?vue&type=script&lang=js"
export * from "./AllBalancesHomeView.vue?vue&type=script&lang=js"

import "./AllBalancesHomeView.vue?vue&type=style&index=0&id=b88803ce&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b88803ce"]])

export default __exports__